import React, { useEffect, useState } from 'react';
import { createTheme, ThemeProvider, Button, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Container, Form, Col, Row } from 'react-bootstrap';
import SyringeIcon from '../../../../icons/SyringeBlue.svg';
import SvgIcon from '@material-ui/core/SvgIcon';
import { SelectInput, TextInput, StyledRadioInput } from "../../../Helpers/Inputs";
import { NumberFormatDollars } from '../../../Helpers/Formatters';
import { AutocompleteInput } from '../../../Helpers/Inputs';
import LaborIcon from '../../../../icons/labor.svg';
import LightLaborIcon from '../../../../icons/lightLabor.svg';
import ProfessionalIcon from '../../../../icons/professional.svg';
import TechnicalIcon from '../../../../icons/technical.svg';
import ProtectMyFutureIcon from '../../../../icons/protectMyFuture.svg';
import MoneyIcon from '../../../../icons/money.svg';
import MaternityLeaveIcon from '../../../../icons/maternityLeave.svg';
import './EmploymentDetails.scss';

const OCCUPATION_NOT_FOUND = "CAN'T FIND YOUR OCCUPATION?";


export default function EmploymentDetails(props) {
    const [occupationOptions, setOccupationOptions] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [criteria,setCriteria] = useState([])
    const [occupationList, setOccupationList] = useState([]);

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: EmploymentDetails.ValidationSchema(criteria && criteria.length),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
        setValue(field, value);
    };

    const handleCurrentOccupationValueChange = (field, value) => {
        handleValueChange(field, value);
        triggerValidation(field);
    };

    const handleOccupationCategoryValueChange = (field, value) => {
        handleValueChange(field, value);
        triggerValidation(field);
    };

    const handleOccupationValueChange = (field, value) => {
        handleValueChange(field, value);
        triggerValidation(field);
    };

    const handleWorkHoursValueChange = (field, value) => {
        handleValueChange(field, value);
        triggerValidation(field);
    };

    const handleDescriptionValueChange = (field, value) => {
        handleValueChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'occupation' });
        setValue('occupation', props.formState.occupation);
        register({ name: 'workHours' });
        setValue('workHours', props.formState.workHours);
        register({ name: 'annualIncome' });
        setValue('annualIncome', props.formState.annualIncome);
        register({ name: 'description' });
        setValue('description', props.formState.description);
        register({ name: 'currentOccupation' });
        setValue('currentOccupation', props.formState.currentOccupation);
        register({ name: 'occupationCategory' });
        setValue('occupationCategory', props.formState.occupationCategory);
        register({ name: 'jobTitle' });
        setValue('jobTitle', props.formState.jobTitle);
    }, []);

    useEffect(() => {
        if(props.formState.currentOccupation != '' && props.formState.currentOccupation !== OCCUPATION_NOT_FOUND){
            let criteriaListOptions = props.formState.occupationList.find(e => e.value === props.formState.currentOccupation);
            let criteriaList = criteriaListOptions && criteriaListOptions.criteria;
            setCriteria(criteriaList);
        }
    }, [props.formState.currentOccupation]);


    //   }, [props.formState.currentOccupation]);
    let debounce = null;

    const handleInputChange = (e, val) => {
        let isSubscribed = true;
        if (debounce) {
            clearTimeout(debounce);
        }
        if (val.length !== 3)
            return

        debounce = setTimeout(() => getOccupation(() => isSubscribed), 1000);
        setIsDisabled(true)
        const getOccupation = () => {

            const queryParams = new URLSearchParams({
                term: val,
                limit: 25,
                state: props.basicInfo.state
            });
            const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL
            fetch(`${covrServicesUrl}/api/Case/GetOccupationList?${queryParams.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
                })
                .then(res => res.json())
                .then((data) => {
                    if (data.isSuccess && data.result && data.result.length > 0) {
                        setOccupationList(data.result);
                        let opt = [];
                        let fullForm = {...props.fullFormState};
                        data.result.map((index) => {
                            let criteria = []
                            
                            if (index.subCriteria && index.subCriteria.length > 0) {
                                index.subCriteria.map(ind => {
                                    criteria.push({ label: ind.text, value: ind.text })
                                })
                            }
                            opt.push({ label: index.jobTitle, value: index.jobTitle, criteria: criteria })
                        })
                        fullForm.pages.employmentDetails.occupationList = opt;
                        props.onMultiFieldChange(fullForm);
                        setOccupationOptions(opt);
                    }
                    setIsDisabled(false);

                })
       
        }
        return () => {
            clearTimeout(debounce);
            isSubscribed = false;
        }
    }

    const getDescribeOptions = [
        { label: "Protect my future", value: "Protect my future", secondaryText: "Looking for disability insurance to protect me if I become disabled in the future and can't work.", icon: ProtectMyFutureIcon },
        { label: "Maternity Leave", value: "Maternity Leave", secondaryText: "Looking for coverage to supplement my income during maternity leave.", icon: MaternityLeaveIcon },
        { label: "Financial Assistance", value: "Financial Assistance", secondaryText: "Currently disabled or not working and I'm looking for financial assistance.", icon: MoneyIcon }
    ]

    const getOccupationOptions = [
        { label: "Professional", value: "Professional", secondaryText: "Office job with few hazards. Examples: accountant, pharmacist, software engineer.",icon:ProfessionalIcon },
        { label: "Technical", value: "Technical", secondaryText: "Similar to Professional, but with some hazards. Examples: salesperson, dental hygienist, lab tech.",icon:TechnicalIcon },
        { label: "Light Labor", value: "Light Labor", secondaryText: "Skilled/manual jobs in lighter industries. Examples: auto mechanic, carpenter, landscaper.",icon:LightLaborIcon },
        { label: "Labor", value: "Labor", secondaryText: "Heavier or unskilled manual jobs with more hazards. Examples: ride share driver, roofer, etc.",icon:LaborIcon },
    ];

    const useStyles = makeStyles(theme => ({
        stepContainer: {
          backgroundColor: '#f9f9f9',
          border: '1px solid #e2e2e2',
          borderRadius: '0 0 4px 4px',
          paddingTop: '48px',
          marginTop: '-48px',
        },
        lightBackground: {
          backgroundColor: `${theme.palette.primary.main}16`,
        },
    }));

    const classes = useStyles();

    const lastListItem = (theme) => {
        return {
            overrides: {
                MuiInputBase: {
                    input: {
                        fontSize: 16,
                    },
                    root: {
                        height: 56,
                    },
                },
                MuiFilledInput: {
                    root: {
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                    },
                    underline: {
                        "&::before": {
                            borderBottom: "solid 2px #b2b2b2",
                        },
                        "&:hover::before": {
                            borderBottomWidth: "2px",
                        },
                    },
                },
                MuiFormLabel: {
                    root: {
                        fontSize: 16,
                        color: "rgba(0,0,0,0.6)",
                    }
                },
                MuiFormHelperText: {
                    root: {
                        marginTop: 0,
                        paddingTop: 0,
                    },
                },
                MuiInputLabel: {
                    shrink: {
                        color: "rgba(0,0,0,0.3) !important",
                    },
                },
                MuiSelect: {
                    fontSize: 16,
                    icon: {
                        color: "rgba(0,0,0,1)"
                    },
                    iconFilled: {
                        right: 16,
                    },
                },
                MuiAutocomplete: {
                    endAdornment: {
                        display: "none"
                    },
                    option: {
                        "&:last-child": {
                            color: theme.palette.primary.main,
                            fontWeight: "bold",
                        }
                     },
                },
            },
        };
    }
    const onSubmit = () => {
        let fullForm = {...props.fullFormState};
        if(occupationList){
            let selectedOccupation = occupationList && occupationList.find(el => el.jobTitle === props.formState.currentOccupation);
            if(selectedOccupation && selectedOccupation.occClasses.length > 0){
                fullForm.pages.employmentDetails.occupationClass = selectedOccupation.occClasses[0].occClass;
                fullForm.pages.employmentDetails.discounts = selectedOccupation.occClasses[0].discounts;
            }else if(selectedOccupation && occupationOptions && props.formState.currentOccupation !== '' && props.formState.currentOccupation !== OCCUPATION_NOT_FOUND && criteria && criteria.length > 0 ){
                let selectedCriteria = selectedOccupation.subCriteria.find(el => el.text === props.formState.occupationCategory);
                fullForm.pages.employmentDetails.occupationClass = selectedCriteria.occClasses[0].occClass;
                fullForm.pages.employmentDetails.discounts = selectedCriteria.occClasses[0].discounts;
            }
            props.onMultiFieldChange(fullForm);
            props.onNext();
        }
    }

    const filterOccupationOptions = (options,state) => {
            let newOptions = [];
            if(state.inputValue.length>=3){options.forEach((element) => {
            if (element.label.toLowerCase().includes(state.inputValue.toLowerCase())) newOptions.push(element);
            });
            if(newOptions.length>0 || (!isDisabled && newOptions.length===0 && state.inputValue.length>=3) )
            newOptions.push({ label: OCCUPATION_NOT_FOUND, value: OCCUPATION_NOT_FOUND, criteria: [] })}
            return newOptions;
    }
    
    return (
        <ThemeProvider theme={(theme) => createTheme({
            ...theme,
            ...lastListItem(theme),
        })}>
            <Container className={`employment-details ${classes.stepContainer}`}>
                <Row className="justify-content-center pt-2">
                    <div className={`icon-container ${classes.lightBackground}`}>
                        <SvgIcon component={SyringeIcon} fontSize="large" color="primary" />
                    </div>
                </Row>
                <Row className="justify-content-center mainTitle">
                    <h4>Employement Details</h4>
                </Row>
                <Form onSubmit={handleSubmit(onSubmit)} >
                    <Row className="justify-content-center">
                        <Col lg={4}>
                            <Form.Group>
                                <AutocompleteInput
                                    name="currentOccupation"
                                    id="currentOccupation"
                                    defaultValue={props.formState.currentOccupation}
                                    onInputChange={(e, val, reason) => { if (reason === 'input') handleInputChange(e, val) }}
                                    errors={errors && errors.currentOccupation}
                                    label="Current Occupation"
                                    inputRef={register}
                                    disabled={isDisabled}
                                    selectOptions={occupationOptions}
                                    onChange={(value) => handleCurrentOccupationValueChange('currentOccupation', value)}
                                    filterOptions={(options, state) => filterOccupationOptions(options,state)}  
                                />
                            </Form.Group>  
                            {
                                occupationOptions && props.formState.currentOccupation !== '' && props.formState.currentOccupation !== OCCUPATION_NOT_FOUND && criteria && criteria.length > 0 &&
                                <Form.Group>
                                    <SelectInput
                                        name="occupationCategory"
                                        id="occupationCategory"
                                        value={props.formState.occupationCategory}
                                        onChange={e => handleOccupationCategoryValueChange('occupationCategory', e.target.value)}
                                        label="Occupational Category"
                                        selectOptions={criteria}
                                        errors={errors && errors.occupationCategory}
                                        placeholder="Select a Category"
                                    />
                                </Form.Group>
                            }
                            {
                                props.formState.currentOccupation === OCCUPATION_NOT_FOUND &&
                                <Form.Group>
                                    <SelectInput
                                        name="occupation"
                                        id="occupation"
                                        value={props.formState.occupation}
                                        onChange={e => handleOccupationValueChange('occupation', e.target.value)}
                                        label="Occupation Type"
                                        selectOptions={getOccupationOptions}
                                        errors={errors && errors.occupation}
                                        isImageOptions={true}
                                        renderValue={(value) => {
                                            return (value)
                                        }}
                                    />
                                </Form.Group>
                            }
                            {
                                props.formState.currentOccupation === OCCUPATION_NOT_FOUND &&
                                <TextInput
                                    name="jobTitle"
                                    id="jobTitle"
                                    value={props.formState.jobTitle}
                                    onChange={(e) => handleValueChange('jobTitle', e.target.value)}
                                    label="Job Title"
                                    inputRef={register}
                                    errors={errors.jobTitle}
                                />
                            }
                            <Form.Group className='mt-3 mb-0'>
                                <StyledRadioInput
                                    name="workHours"
                                    id="workHours"
                                    label="Do you work at least 30 hours a week?"
                                    value={props.formState.workHours}
                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                    onChange={e => handleWorkHoursValueChange('workHours', e)}
                                    errors={errors && errors.workHours}
                                    inputRef={props.register}
                                />
                            </Form.Group>
                            <Form.Group>
                                <TextInput
                                    name="annualIncome"
                                    id="annualIncome"
                                    label="Annual Income"
                                    value={props.formState.annualIncome}
                                    onChange={e => handleValueChange('annualIncome', e.target.value)}
                                    InputProps={{
                                        inputComponent: NumberFormatDollars,
                                    }}
                                    inputRef={register}
                                    errors={errors.annualIncome}
                                />
                            </Form.Group>
                            <Form.Group className="mb-0">
                                <SelectInput
                                    name="description"
                                    id="description"
                                    value={props.formState.description}
                                    onChange={e => handleDescriptionValueChange('description', e.target.value)}
                                    label="Reason for Coverage"
                                    selectOptions={getDescribeOptions}
                                    errors={errors && errors.description}
                                    isImageOptions={true}
                                    renderValue={(value) => {
                                        return (value)
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="nav-control">
                        <Col className="text-left btn-back">
                            <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack} >BACK</Button>
                        </Col>
                        <Col className="text-right">
                            <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">NEXT</Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </ThemeProvider>
    );
}

EmploymentDetails.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    hideBack: PropTypes.bool,
};

EmploymentDetails.ValidationSchema = (criteria) => {
    return object().shape({
        currentOccupation: string().required('This field is required'),
        occupationCategory: string().when('currentOccupation', {
            is: (currentOccupation) => currentOccupation !== OCCUPATION_NOT_FOUND && criteria>0,
            then: string().required('This field is required'),
            otherwise: string().notRequired(),
        }),
        occupation: string().when('currentOccupation', {
            is: (currentOccupation) => currentOccupation === OCCUPATION_NOT_FOUND,
            then: string().required('This field is required'),
            otherwise: string().notRequired(),
        }),
        jobTitle: string().when(['occupation','currentOccupation'], {
            is: (occupation,currentOccupation) => occupation === OCCUPATION_NOT_FOUND && currentOccupation === OCCUPATION_NOT_FOUND,
            then: string().required('This field is required'),
            otherwise: string().notRequired(),
        }),
        workHours: string().required('This field is required'),
        annualIncome: string().required('This field is required'),
        description: string().required('This field is required')
    })
};

EmploymentDetails.DefaultFormState = (prefill = false) => {
    return {
        occupation: '',
        workHours: '',
        annualIncome: '',
        description: '',
        currentOccupation: '',
        occupationCategory: '',
        jobTitle: '',
        occupationClass: '',
        discounts: []
    };
};


// WEBPACK FOOTER //
// ./src/components/Quoters/LongTerm/steps/EmploymentDetails.js